import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
  author: Vender Aleksandr
  version: 1.0.0
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);

/**
  - Компонент переключет картинки между desktop и mobile.
    Если передать source будет использует в себе tag <picture/>, что
    дает гибкость в использовании при адаптиве;

  ⬇︎⬇︎⬇︎ Способ применения симореть в конце файла ⬇︎⬇︎⬇︎
*/
export var Picture = /*#__PURE__*/function (_Component) {
  function Picture() {
    _classCallCheck(this, Picture);
    return _callSuper(this, Picture, arguments);
  }
  _inherits(Picture, _Component);
  return _createClass(Picture, [{
    key: "renderImage",
    value: function renderImage() {
      var _this$props = this.props,
        alt = _this$props.alt,
        className = _this$props.className,
        src = _this$props.src,
        title = _this$props.title,
        lazy = _this$props.lazy,
        mobileOnly = _this$props.mobileOnly,
        desktopOnly = _this$props.desktopOnly;
      return /*#__PURE__*/React.createElement("img", {
        alt: alt,
        className: cx({
          mobileOnly: mobileOnly,
          desktopOnly: desktopOnly
        }, className),
        loading: lazy ? 'lazy' : undefined,
        src: src,
        title: title,
        "data-t-id": "components-Picture"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        src = _this$props2.src,
        mobileOnly = _this$props2.mobileOnly,
        desktopOnly = _this$props2.desktopOnly,
        mobileSrc = _this$props2.mobileSrc,
        pictureClassName = _this$props2.pictureClassName;
      var source = this.props.source;
      if (mobileOnly || desktopOnly) {
        source = [{
          media: 'max-width: 767px',
          srcSet: mobileOnly ? src : Picture.emptyImage
        }, {
          media: 'min-width: 768px',
          srcSet: desktopOnly ? src : Picture.emptyImage
        }];
      } else if (mobileSrc) {
        source = [{
          media: 'max-width: 767px',
          srcSet: mobileSrc
        }];
      }
      if (source) {
        return /*#__PURE__*/React.createElement("picture", {
          className: pictureClassName
        }, source.map(function (item, index) {
          return item && /*#__PURE__*/React.createElement("source", {
            key: "source-".concat(index),
            media: "(".concat(item.media, ")"),
            srcSet: item.srcSet,
            type: item.type || undefined
          });
        }), this.renderImage());
      }
      return this.renderImage();
    }
  }]);
}(Component);
_defineProperty(Picture, "emptyImage", '//static.beeline.ru/upload/images/b2c/0.png');
Picture.propTypes = process.env.NODE_ENV !== "production" ? {
  src: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
  mobileSrc: PropTypes.string,
  lazy: PropTypes.bool,
  mobileOnly: PropTypes.bool,
  desktopOnly: PropTypes.bool,
  source: PropTypes.arrayOf(PropTypes.shape({
    srcSet: PropTypes.string,
    media: PropTypes.string
  })),
  className: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  pictureClassName: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
} : {};
Picture.defaultProps = {
  alt: ''
};

/**
--- Способ применения ---

<Picture
  src={webImage}
  className={cx('bgImage')}
  alt="Flowers"
  source={[{
    srcSet: mobImage,
    media: 'max-width: 768px',
  }]}
/>

<Picture
  src={webImage}
  mobileSrc={mobImage}
  className={cx('bgImage')}
  alt="Flowers"
/>

<Picture
  src={imageSrc}
  alt="image_from_static"
/>
*/